// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J2Tp4","tabsBox":"styles_tabsBox__1C0l9","createButton":"styles_createButton__2xjNr"};